export const AGENT_SHARED_FIELD = {
  field: '6529becdf8df3723b81c9711',
  value: '',
  ownerId: '',
  ownerModel: 'Client',
};
